import { useLocation as useRouterLocation, useNavigate } from 'react-router-dom'

const useLocation = () => {
  const location = useRouterLocation()
  const navigate = useNavigate()
  return { location, navigate }
}

export default useLocation
